import { render, staticRenderFns } from "./TermsAndConditionsModal.vue?vue&type=template&id=0758357f&scoped=true"
import script from "./TermsAndConditionsModal.vue?vue&type=script&lang=ts"
export * from "./TermsAndConditionsModal.vue?vue&type=script&lang=ts"
import style0 from "./TermsAndConditionsModal.vue?vue&type=style&index=0&id=0758357f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0758357f",
  null
  
)

export default component.exports